import React, { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { trackEvent } from "@/components/Analytics";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const ContactForm = () => {
    const [form, setForm] = useState({
        name: "",
        email: "",
        subject: "",
        message: "",
    });
    const [rgpd, setRgpd] = useState(false);
    const [submitting, setSubmitting] = useState(false);

    const set = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

    const submit = async (e) => {
        e.preventDefault();
        if (!rgpd) {
            toast.error(
                "Precisa de aceitar o armazenamento das suas informações (RGPD).",
            );
            return;
        }
        setSubmitting(true);
        try {
            await axios.post(`${API}/contact`, form);
            trackEvent("contact_form_submit", { subject: form.subject });
            toast.success(
                "Mensagem enviada com sucesso! Entraremos em contacto brevemente.",
            );
            setForm({ name: "", email: "", subject: "", message: "" });
            setRgpd(false);
        } catch (err) {
            toast.error(
                "Ocorreu um erro ao enviar. Por favor, tente novamente.",
            );
        } finally {
            setSubmitting(false);
        }
    };

    return (
        <form onSubmit={submit} className="space-y-4" data-testid="contact-form">
            <div>
                <label className="acd-label">Nome Completo *</label>
                <input
                    className="acd-input"
                    required
                    value={form.name}
                    onChange={set("name")}
                    data-testid="contact-name"
                />
            </div>
            <div>
                <label className="acd-label">E-mail *</label>
                <input
                    type="email"
                    className="acd-input"
                    required
                    value={form.email}
                    onChange={set("email")}
                    data-testid="contact-email"
                />
            </div>
            <div>
                <label className="acd-label">Assunto *</label>
                <input
                    className="acd-input"
                    required
                    value={form.subject}
                    onChange={set("subject")}
                    data-testid="contact-subject"
                />
            </div>
            <div>
                <label className="acd-label">Mensagem *</label>
                <textarea
                    className="acd-textarea"
                    rows={5}
                    required
                    value={form.message}
                    onChange={set("message")}
                    data-testid="contact-message"
                />
            </div>
            <label className="flex items-start gap-3 text-sm text-gray-700">
                <input
                    type="checkbox"
                    checked={rgpd}
                    onChange={(e) => setRgpd(e.target.checked)}
                    className="mt-1 h-4 w-4 accent-[var(--acd-blue-600)]"
                    data-testid="contact-rgpd"
                />
                <span>
                    <strong>RGPD:</strong> Concordo que este site armazene as
                    informações enviadas por mim neste pedido, de forma a que a
                    ACD Advogados possa responder à minha solicitação.
                </span>
            </label>
            <button
                type="submit"
                disabled={submitting}
                className="acd-btn-gradient"
                data-testid="contact-submit"
            >
                {submitting ? "A enviar..." : "Enviar Mensagem"}
            </button>
        </form>
    );
};

export default ContactForm;
